import { inject } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthFacade } from '~console/app/~store/facades/auth.facade';
import { DashboardFacade } from '~console/app/~store/facades/dashboard.facade';
import { UserRole } from '~core/models/auth.models';
import { OrganizationSwitcherDialogComponent } from '../components/modals/organization-switcher-dialog/organization-switcher-dialog.component';
import { DialogService } from '../services/dialog.service';

export const DASHBOARD_GUARD = (): Observable<UrlTree | boolean> | boolean => {
  const authFacade = inject(AuthFacade);
  const dashboardFacade = inject(DashboardFacade);
  const dialogService = inject(DialogService);

  const currentUser = authFacade.currentUser;
  const currentOrganization = dashboardFacade.currentOrganization;

  if (
    !currentOrganization &&
    (currentUser?.roles.includes(UserRole.ROLE_SUPER_ADMIN) ||
      currentUser?.roles.includes(UserRole.ROLE_ADMIN))
  ) {
    dialogService.open({
      component: OrganizationSwitcherDialogComponent,
      config: {
        panelClass: ['mat-dialog-custom', 'w-[520px]'],
        maxWidth: '520px',
        disableClose: true
      }
    });
  }

  return true;
};
